/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CarrierCustomerType = {
    Individual: 'INDIVIDUAL',
    Business: 'BUSINESS'
} as const;
export type CarrierCustomerType = typeof CarrierCustomerType[keyof typeof CarrierCustomerType];

